import { Card, Carousel, Col, Divider, Row, Space } from 'antd';
import React from 'react';
import ExternalLinkButton from './ExternalLinkButton';
import NoticeBoardParent from './NoticeBoardParent';
import VibhagParent from './VibhagParent';
import ExternalLinks from './ExternalLinks';
import { Link, useNavigate } from 'react-router-dom';
import HomePhotoGallery from './HomePhotoGallery';
import HomeVideoGallery from './HomeVideoGallery';
import pskagalbuilding from "../../assets/images/website/pskagalbuilding.jpeg";
import home3 from "../../assets/images/website/home3.jpg";
import home4 from "../../assets/images/website/home4.jpg";
import home5 from "../../assets/images/website/home5.jpg";
import home6 from "../../assets/images/website/home6.jpg";
import home7 from "../../assets/images/website/home7.jpg";

const HomeComponent = () => {
    const navigate = useNavigate();

    return (
        <>
            <Row gutter={16}>
                <Col xl={17} lg={17} md={24} sm={24} xs={24} style={{ textAlign: "center" }}>
                    <Space direction='vertical' style={{ width: "100%" }}>
                        <Card className='card-border'>
                            <Carousel autoplay>
                                <div>
                                    <img src={pskagalbuilding} style={{ width: "100%" }} />
                                </div>
                                {/* <div>
                                    <img src={home3} style={{ width: "100%" }} />
                                </div>
                                <div>
                                    <img src={home4} style={{ width: "100%" }} />
                                </div>
                                <div>
                                    <img src={home5} style={{ width: "100%" }} />
                                </div>*/}
                                <div>
                                    <img src={home6} style={{ width: "100%" }} />
                                </div> 
                                <div>
                                    <img src={home7} style={{ width: "100%" }} />
                                </div>
                            </Carousel>

                            <p style={{ fontSize: 18 }}>पंचायत समिती कागलच्या संकेतस्थळावर आपले स्वागत आहे. पंचायत समिती संकेतस्थळ सर्वच स्तरातील नागरिकांकरिता कार्यान्वीत करतांना ती लोकाभिमुख असावी यास्तव प्रयत्न करण्यात आला आहे.
                                शासनाच्या माहिती व तंत्रज्ञान विषयक धोरणाचा अवलंब करतांना पंचायत समिती मधील विविध योजना व त्याची परिपुर्ण माहिती तसेच विविध विभागांची माहिती
                                संकेतस्थळावर उपलब्ध करण्यांत आली आहे. </p>
                        </Card>

                        <VibhagParent />

                        <ExternalLinks />
                    </Space>
                </Col>
                <Col xl={7} lg={7} md={24} sm={24} xs={24}>
                    <Space direction='vertical' style={{ width: "100%" }}>
                        <Row>
                            <Col span={24}>
                                <NoticeBoardParent apiUrl="/website/home/suchana" title="सूचना फलक" />
                            </Col>
                        </Row>
                        {/* <Row>
                            <Col span={24}>
                                <NoticeBoardParent apiUrl="/website/home/grampanchayati" title="ग्रामपंचायती" />
                            </Col>
                        </Row> */}
                        <ExternalLinkButton label="लोकसेवा हक्क अधिनियम 2015" onClick={() => { navigate("/lokseva"); }} />
                        <Row>
                            <Col span={24}>
                                <NoticeBoardParent apiUrl="/website/home/important-forms" title="महत्वाचे फॉर्म" />
                            </Col>
                        </Row>
                        <Row>
                            <Col span={24}>
                                <ExternalLinkButton label="माहितीपूर्ण व्हिडिओ" onClick={() => { navigate("/video-gallery") }} />
                                <ExternalLinkButton label="फोटो गॅलरी" onClick={() => { navigate("/photo-gallery") }} />
                                <ExternalLinkButton label="निविदा" onClick={() => { navigate("/nivida") }} />
                            </Col>
                        </Row>
                    </Space>
                </Col>
            </Row>

            <Row>
                <Divider><Link to={"/photo-gallery"} style={{ color: "#0d6efd", textDecoration: "underline" }}>फोटो गॅलरी</Link></Divider>
                <HomePhotoGallery />
            </Row>
            <Row>
                <Divider><Link to={"/video-gallery"} style={{ color: "#0d6efd", textDecoration: "underline" }}>विडियो गॅलरी</Link></Divider>
                <HomeVideoGallery />
            </Row>
        </>
    );
}

export default HomeComponent;